<template>
  <h3 class="text-capitalize">
    <slot name="before"></slot>
    <span class="d-block-inline" v-html="title"></span>
    <slot></slot>
  </h3>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style>
</style>